import { TeamSide } from '@/utils/sport-utils';

import { Option, OptionType } from '../types';

export const SET_BETTING_MARKET_CODE = 'SET_BETTING';

export type SetBettingColumns = Record<TeamSide, Array<Option>>;

// Set-betting options carry only the set score; the side is whoever wins more sets.
export const getSetBettingOptionSide = (optionType: OptionType): TeamSide | undefined => {
    const { CORRECT_SCORE_HOME, CORRECT_SCORE_AWAY } = optionType.params;
    if (CORRECT_SCORE_HOME === undefined || CORRECT_SCORE_AWAY === undefined) {
        return undefined;
    }
    return CORRECT_SCORE_HOME > CORRECT_SCORE_AWAY
        ? 'home'
        : CORRECT_SCORE_AWAY > CORRECT_SCORE_HOME
        ? 'away'
        : undefined;
};

export const groupSetBettingOptions = (options: Array<Option>): SetBettingColumns => {
    return options.reduce<SetBettingColumns>(
        (columns, option) => {
            const side = getSetBettingOptionSide(option.option_type);
            if (side) {
                columns[side].push(option);
            }
            return columns;
        },
        { home: [], away: [] }
    );
};
